import { useCallback } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { ButtonsModalSmallCentered, ModalSmallCenteredOutside } from '../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../baseComponents/Modal/types'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import CustomSelect, { CustomSelectWithSearchBar } from '../../../../../forms/CustomSelect'
import { InputHidden, InputWithLabelMarginIntegerStateFull } from '../../../../../forms/Input'
import TwinForm from '../../../../../forms/TwinForm'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../forms/TwinForm/types'
import { twinFetchPostPrinter } from '../../../../../utils/globals/data'
import withLoading from '../../../../../utils/hoc/withLoading'
import useProductPrintTagsDict from '../../../../../utils/hooks/product/useProductPrintTagsDict'
import useIsLoading from '../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../utils/reducers'
import { LabelsPayload } from '../../../../../utils/reducers/company/labels'
import { SpecificPriceRulesPayload } from '../../../../../utils/reducers/products/specificPriceRules'
import './modalPrintProductTags.sass'

type ModalPrintProductTagsProps = ModalEditComponentProps & ReduxModalPrintProductTags & {} 

const ModalPrintProductTags: React.FC<ModalPrintProductTagsProps> = ({ setOpened, labels, specificPriceRules, basicData}) => {
    const { loading, onPreSubmit, onSubmit } = useModalPrintProductTagsLogic({ setOpened })
    const { t } = useTwinTranslation()
    const dictPrintProductType = useProductPrintTagsDict()
    return (
        <ModalSmallCenteredOutside opened={true} setOpened={setOpened} onClickOut={false} className='flex_height'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action='/api/app/product/printProductTags' onSubmit={onSubmit} className='flex flex-auto flex-col justify-between gap-10 ' triggerErrors={false} triggerSuccess={false}>
                <CustomSelectWithSearchBar items={labels || {}} label={t('tag', 'Etiqueta')} value={Object.keys(labels || {})?.[0] || ''} name='LabelId' required={true} />
                <CustomSelectWithSearchBar items={specificPriceRules?.dictionary || {}} label={t('specificPriceRule', 'Tarifa')} value={specificPriceRules?.arrSorted?.[0]?.id || ''} name='SpecificPriceRuleId' required={true} />
                {basicData?.isVariantProduct ? 
                    <CustomSelect items={dictPrintProductType} label={t('typeProducts', 'Tipo de productos')} value={'onlyVariants'} name='typeProducts' required={true} /> : 
                    <InputHidden name='typeProducts' value='onlyMain' />
                }
                <InputWithLabelMarginIntegerStateFull className={'text-start w-full print_product_tags'} label={t('tagQuantity', 'Cantidad de etiquetas')} minValue={1}  defaultValue={1} name='tagQuantity' required={true} />
                <InputHidden name='ProductId' value={basicData?.id} />
                <ButtonsModalSmallCentered confirmText={t('print', 'Imprimir')} setOpened={() => { }} onCancel={() => setOpened(null)} loading={loading} />
            </TwinForm>
        </ModalSmallCenteredOutside>
    )
}

interface ModalPrintProductTagsLogicProps {
    setOpened: ModalOpenedSetTy
}

const useModalPrintProductTagsLogic = ({ setOpened }: ModalPrintProductTagsLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const { t } = useTwinTranslation()
    const errorMessage = t('couldNotConnectWithPrinter', 'No se ha podido conectar con la impresora')
    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        startLoading()
        return true
    }, [startLoading])

    const onSubmit: OnSubmit = useCallback(async (result) => {
        if (result && result.status === 367) {
            const body = await result.json()
            const myresult = await twinFetchPostPrinter('/printLabel', body, errorMessage)
            if (myresult) {
                setOpened(null)
            }
        }
        endLoading()
    }, [endLoading, setOpened, errorMessage])
    return { onPreSubmit, onSubmit, loading, endLoading }
}

const modalPrintTagsDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
    setLabels: (payload: LabelsPayload) => ({ type: 'CHANGE_LABELS', payload }),
}

type ReduxModalPrintProductTags = ConnectedProps<typeof modalprintproducttagsConnect>
const mapModalPrintProductTagsConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules, labels: state.labels })
const modalprintproducttagsConnect = connect(mapModalPrintProductTagsConnector, modalPrintTagsDispatch)

const modalprintproducttagsConnectLoading = withLoading(ModalPrintProductTags, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/config/label/getAllLabels', propName: 'labels', setFunctionName: 'setLabels' }])
const ModalPrintProductTagsConnect = modalprintproducttagsConnect(modalprintproducttagsConnectLoading)

export default ModalPrintProductTagsConnect